import { ErrorOutline } from '@mui/icons-material'
import { Stack, styled, useTheme } from '@mui/material'
import React from 'react'

const StyledDiv = styled(Stack)(
  ({ theme }) => `
    background-color: ${theme.palette.role.errorContainer};
    color: ${theme.palette.role.onSurface};
    padding: 1rem;
    align-items: center;
    gap: 0.5rem;
    align-self: stretch;
    border-radius: 0.75rem;
  `
)

interface ErrorMessageProps {
  children: React.ReactNode
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ children }) => {
  const theme = useTheme()
  return (
    <StyledDiv>
      <ErrorOutline sx={{ color: theme.palette.role.error }} />
      {children}
    </StyledDiv>
  )
}

export default ErrorMessage
